import { render, staticRenderFns } from "./Overseas144Exemptions.vue?vue&type=template&id=67e5bcce&scoped=true&"
import script from "./Overseas144Exemptions.vue?vue&type=script&lang=js&"
export * from "./Overseas144Exemptions.vue?vue&type=script&lang=js&"
import style0 from "./Overseas144Exemptions.vue?vue&type=style&index=0&id=67e5bcce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5bcce",
  null
  
)

export default component.exports